function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M12.778 6.556c.286 0 .518.214.518.478 0 .265-.232.479-.518.479H6.556c-.287 0-.519.214-.519.478v9.573c0 .264.232.479.519.479h9.333c.286 0 .518-.215.518-.479v-4.786c0-.265.233-.479.519-.479.286 0 .518.214.518.479v4.786c0 .793-.696 1.436-1.555 1.436H6.556C5.696 19 5 18.357 5 17.564V7.991c0-.793.696-1.435 1.556-1.435zM17.105 5a1.895 1.895 0 0 1 1.34 3.235l-6.52 6.519a.495.495 0 0 1-.193.12l-2.97.99a.5.5 0 0 1-.312 0 .495.495 0 0 1-.313-.626l.99-2.97a.5.5 0 0 1 .119-.194l6.52-6.519A1.88 1.88 0 0 1 17.105 5z",
  id: "icon-edit-path"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .636)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "icon-edit-mask",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#icon-edit-path"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#icon-edit-path"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon-edit-mask)",
  fill: "gray"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 0v24H0V0z"
})));

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.6bb5f1d5.svg";
export { ForwardRef as ReactComponent };